module.exports = __webpack_public_path__ + "static/media/7.e4fede1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/7.png
// module id = 470
// module chunks = 0